import Vue from 'vue'


const methods = Vue.mixin({

    methods: {
        isIphonex() {
            if (typeof window !== 'undefined' && window) {
                return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
            }
            return false;
        },
        goback() {
            this.$router.back();
        },
        tourl(url, flag = false) {
            // let flags = flag || false;
            // this.$router.isBack = flags;
            this.$router.push(url);
        },
        replaceRoute(url) {
            this.$router.replace(url);
        },
        defImg(url) {
            if (url) {
                if (url.indexOf("*200*200") > -1) {
                    return "http://images.autostreets.com/" + url.replace("*200*200", "*800*800");
                } else {
                    return "http://images.autostreets.com/" + url
                }
            } else {
                return '';
            }
        },
    }
})



export {
    methods
}


// WEBPACK FOOTER //
// ./src/commonjs/vuePrototype.js